// redux
import { useAppSelector } from "../../redux/hooks";
import { selectIsBusy, selectIsDirty, selectHelpUrl, selectUserToken, selectPortalLinks, selectFeatureSwitches } from "../../shell/shellSlice";
// api
import * as Client from "../../api/Client";

export function useIsBusy(): boolean {
    return useAppSelector(selectIsBusy);
}

export function useIsDirty(): boolean {
    return useAppSelector(selectIsDirty);
}

export function useHelpUrl(): string | undefined {
    return useAppSelector(selectHelpUrl);
}

export function useUserToken(): string | undefined {
    return useAppSelector(selectUserToken);
}

export function usePortalLink(name: Client.ExternalLinkEnum): string | undefined {
    const portalLinks = useAppSelector(selectPortalLinks);
    return portalLinks.find((l) => l.name === name)?.url;
}

export function useFeatureSwitch(): FeatureSwitch {
    const featureSwitches = useAppSelector(selectFeatureSwitches);
    return new FeatureSwitch(featureSwitches);
}

export class FeatureSwitch {
    constructor(featureSwitches: Array<Client.NeatsFeatureSwitchEnum>) {
        this._featureSwitches = featureSwitches;
    }

    private _featureSwitches: Array<Client.NeatsFeatureSwitchEnum>;

    public check(featureSwitch: Client.NeatsFeatureSwitchEnum): boolean {
        return this._featureSwitches.some((fs) => fs === featureSwitch);
    }
}
